import { safeLocalStorage } from './safeStorage';
import { recordTriggeredHint } from '../actions/user.actions';
import { RecordTriggeredHintAction } from '../actions/user.actionTypes';
import { ThunkAction } from '../actions/common.actionTypes';
import { onboardingHints } from '../constants';

export const TRIGGERED_HINTS_MIGRATION_FLAG = 'triggeredHints-migrated-v1';

// Hint keys persisted on the user object; the migration copies these from
// legacy localStorage. Add a key here when a new server-backed hint is added.
export const TRIGGERED_HINT_KEYS: string[] = [
  // OnboardingHint (`hint-<id>`)
  `hint-${onboardingHints.aiAssistant.readerHint}`,
  `hint-${onboardingHints.aiAssistant.pageSelector}`,
  `hint-${onboardingHints.aiAssistant.textEditor}`,
  `hint-${onboardingHints.relatedTopics}`,
  // useOnboardingDialog (`onboarding-<id>`)
  `onboarding-${onboardingHints.aiOnlyWelcomeDialog}`,
  `onboarding-${onboardingHints.lbReOnboardingDialog}`,
  // Muki onboarding tour steps
  onboardingHints.aiAssistant.readerHint,
  onboardingHints.aiAssistant.imageGeneratorHint,
  // Feedback dialogs + artifact-generation alert
  onboardingHints.aiAssistant.artifactGenerationOnboardingAlertSeen,
  onboardingHints.mukiBudeFeedback.notShowAgain,
  onboardingHints.aiOnlyFeedback.notShowAgain,
];

// Configured keys the user has marked seen in localStorage.
const collectLegacyTriggeredHints = (): string[] =>
  TRIGGERED_HINT_KEYS.filter(key => safeLocalStorage.getItem(key) === 'true');

/**
 * Per-browser migration of hint seen-state from localStorage to the user
 * object. Runs a single time, gated by a localStorage flag, and is idempotent.
 * Dispatch it after the user has loaded. Remove it and the flag at cleanup.
 */
export function migrateTriggeredHints(): ThunkAction<RecordTriggeredHintAction> {
  return async (dispatch, getState) => {
    const userId = getState().user.me?._id;
    if (!userId) return;
    if (safeLocalStorage.getItem(TRIGGERED_HINTS_MIGRATION_FLAG) === 'true') return;

    collectLegacyTriggeredHints().forEach(key => {
      dispatch(recordTriggeredHint(key));
    });

    safeLocalStorage.setItem(TRIGGERED_HINTS_MIGRATION_FLAG, 'true');
  };
}

export default migrateTriggeredHints;
